import type { ComponentPropsWithRef, ReactNode } from 'react'
import {
    Button,
    type ButtonColor,
    type ButtonSize,
} from '@/React/Shared/Component/Button'
import type { IconNameEnum } from '@/React/Shared/Component/Icon'
import type { ApiFormState } from '@/React/Shared/Component/Forms/ApiForm'

export interface ApiFormButtonProps extends Omit<
    ComponentPropsWithRef<'button'>,
    'color'
> {
    apiForm: ApiFormState
    color?: ButtonColor
    size?: ButtonSize
    loading?: boolean
    loadingText?: string
    iconName?: IconNameEnum
    iconClass?: string
    iconRight?: boolean
    useBookingFormThemeCssVariables?: boolean
    children?: ReactNode
}

export function ApiFormButton({
    apiForm,
    type = 'submit',
    loading,
    disabled = false,
    ...buttonProps
}: ApiFormButtonProps) {
    return (
        <Button
            {...buttonProps}
            as="button"
            type={type}
            loading={loading ?? apiForm.loading}
            disabled={disabled}
        />
    )
}
